<template>
  <header>
    <div class="inner">
      <h1>
        <slot name="title" />
      </h1>
      <div class="prev" @click="handleScrollY">
        <router-link to="/202010/kantou" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    handleScrollY () {
      window.scroll({
        top: this.$store.state.scrollYatTop,
        behavior: 'auto'
      })
    }
  }
}
</script>

<style lang="sass" scoped>
header
  width: 100%
  height: 60px
  background-color: #fff
  border-bottom: 1px solid #ccc
  position: fixed
  top: 0
  left: 0
  z-index: 10
  .inner
    display: flex
    justify-content: center
    align-items: center
    height: 100%
    position: relative
  h1
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    line-height: 1.4
    font-size: 1.6rem
    span
      font-size: 1.2rem
  .prev
    padding: 5px
    position: absolute
    left: 0
    a
      display: block
      width: 12px
      height: 12px
      border-top: 2px solid $black
      border-right: 2px solid $black
      transform: rotate(225deg)
</style>
